import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(m[1]);
    completeGoogleLogin(session_id)
      .then(() => navigate("/portal", { replace: true }))
      .catch(() => navigate("/login?error=auth", { replace: true }));
  }, [location.hash, completeGoogleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-soft" data-testid="auth-callback">
      <div className="flex items-center gap-3 text-navy/70">
        <Loader2 className="w-5 h-5 animate-spin" /> Completing sign-in…
      </div>
    </div>
  );
}
